import {Injectable} from '@angular/core';
import { Headers, Response, URLSearchParams, RequestOptions } from '@angular/http';
import {HttpAuth} from './http-auth.service';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import { Reminder } from '../models/reminder';
import 'rxjs/add/operator/map';

@Injectable()
export class ReminderService {

  private reminderUrl: string = `${ environment.apiRoot }/reminder/`;

  constructor(private http: HttpAuth) { }

  public getReminderList(startdate: string, enddate: string, page?: number, pagecount?: number, query?: string): Observable<any> {
    const params: URLSearchParams = new URLSearchParams();

    if (page != null) {
      params.append('page', String(page));
    }

    if (pagecount != null) {
      params.append('pagecount', String(pagecount));
    }

    if (query) {
        params.set('query', query);
    }

    if (startdate) {
      params.append('startdate', String(startdate));
    }

    if (enddate) {
        params.append('enddate', String(enddate));
    }

    const options = new RequestOptions({search: params});

    return this.http.get(this.reminderUrl, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public putReminder(reminder:Reminder): Observable<Reminder> {
    const headers = new Headers({
      'Content-Type': 'application/json',
      'X-API-KEY': environment.apiKey
    });

    return this.http.put(this.reminderUrl,reminder,{headers: headers})
      .map(this.extractData)
      .catch(this.handleError);
  }

  public postReminder(reminder:Reminder): Observable<Reminder> {
    const headers = new Headers({
      'Content-Type': 'application/json',
      'X-API-KEY': environment.apiKey
    });

    return this.http.post(this.reminderUrl,reminder,{headers: headers})
      .map(this.extractData)
      .catch(this.handleError);
  }

  public deleteReminder(reminderID): Observable<Reminder> {
    const headers = new Headers({
      'Content-Type': 'application/json',
      'X-API-KEY': environment.apiKey,
      'id': reminderID
    });

    return this.http.delete(this.reminderUrl+"?id="+reminderID,{headers: headers})
      .map(this.extractData)
      .catch(this.handleError);
  }

  //noinspection JSMethodCanBeStatic
  private extractData(res: Response) {
    let body = res.json();
    return body.data || {};
  }

  //noinspection JSMethodCanBeStatic
  private handleError(error: Response | any) {
    let errMsg: string;

    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.meta && body.meta.message || JSON.stringify(body);
      errMsg = `${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }

    console.error(errMsg);

    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/services/reminder.service.ts